var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-progress-linear',{attrs:{"buffer-value":_vm.bufferValue,"value":_vm.progress,"stream":"","color":"orange"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }